<template>
	<div class="setting_ps px-7 py-4">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
export default {
	name: 'SettingsGroups',
	components: {},
	props: {},
	computed: {},
	methods: {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
::v-deep {
	.v-data-table__wrapper {
		max-height: none;
		overflow: auto;
	}
}
</style>
